import React from "react";
import Grid2 from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getTenantLogo, useTenantBranding } from "../../utils/tenantBranding";

const Welcome = () => {
  const { t } = useTranslation();
  const branding = useTenantBranding();
  const logo = getTenantLogo(branding, "white");

  return (
    <Grid2
      component="div"
      size={{ xs: 12, md: 6 }}
      sx={{
        backgroundImage: `url('/images/welcome.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 4,
      }}
    >
      <Box sx={{ gap: 4 }}>
        <Typography variant="h1" fontWeight="bold" gutterBottom>
          {t("welcomeTo")}
        </Typography>
        <img src={logo} alt={`${branding.displayName} Logo`} height={37} />
      </Box>
    </Grid2>
  );
};

export default Welcome;
